/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from "react";
import { DatePicker, Form } from "antd";
import MaskedInput from "antd-mask-input";
import locale from "antd/es/date-picker/locale/es_ES";
import "moment/locale/es";

import DocumentationContext from "../../store/documentation-context";
import { required } from "./../../services/forms";

import classes from "./acta-form.module.scss";

const ActaForm = (props) => {
  const { form } = props;

  const documentationCtx = useContext(DocumentationContext);

  useEffect(() => {
    form.setFieldsValue({
      numero: documentationCtx.numero,
      anio: documentationCtx.anio,
      documento: documentationCtx.documento,
    });
  }, []);

  return (
    <div className={classes.form}>
      <Form form={form} layout="vertical">
        <Form.Item label="Número de Acta" name="numero" rules={[required]}>
          <MaskedInput mask="111111" placeholderChar=" " />
        </Form.Item>
        <Form.Item label="Año" name="anio" rules={[required]}>
          <DatePicker locale={locale} picker="year" placeholder="" />
        </Form.Item>
        <Form.Item label="Documento" name="documento" rules={[required]}>
          <MaskedInput mask="11111111" placeholderChar=" " />
        </Form.Item>
      </Form>
    </div>
  );
};

export default ActaForm;
